<template>
  <div id="app">
    <router-view/>
<!--    <div @click="add" style="color: red">点我+1:{{count}}</div>-->
  </div>
</template>
<script>
// MetaMask 文档 https://docs.metamask.io/guide/ethereum-provider.html#table-of-contents
import store from './store'
import { mapState } from 'vuex'
export default {
  computed: mapState({
    // 箭头函数可使代码更简练
    count: state => state.count
  }),
  name: 'App',
  created() {
    document.title="DAOStarter";
  },
  mounted() {
    this.$store.commit("setMobile");
    //浏览器窗口大小改变的时候将会触发onresize事件
     window.onresize = () => {
       return (() => {
         this.$store.commit("setMobile");
       })();
     };
    this.init();
  },
  methods:{
    init(){
      //如果 MetaMask 提供程序变得无法向任何链提交 RPC 请求，则会发出此事件。通常，这只会由于网络连接问题或一些不可预见的错误而发生。
      //一旦disconnect发出，提供者将不会接受任何新请求，直到重新建立与链的连接，这需要重新加载页面。您还可以使用该ethereum.isConnected()方法来确定提供程序是否已断开连接。
      // ethereum.on('disconnect', (error) => {
      //   console.log("监听断开",error)
      // });

      // ethereum.on('connect',  (connectInfo) => {
      //   console.log("当 MetaMask 提供者第一次能够向链提交 RPC 请求时，它会发出此事件。",connectInfo)
      //   if(ethereum.isConnected()){
      //   }
      // });
    },
    add(){
      store.dispatch('increment')
    },
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Poppins', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*background: url(https://daostarter.pro/static/img/Main-Hero-Robot.cc9b5cf.png)no-repeat;
    background-size: 60%;
    background-position: right 0px top -2%;*/

  }
  .big-orientation{
    display: flex;
    justify-content: center;
  }
  .main-container{
    width: 1150px;
    margin: auto;
  }
  .mobild-container{
    padding: 0 14px;
  }
  body {
    background-color: #0B0E13;
    letter-spacing: 1px;
    font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Segoe UI,Arial,Roboto,PingFang SC,miui,Hiragino Sans GB,Microsoft Yahei,sans-serif;
  }

  .big-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .default-color {
    color: #27DEBF !important;
  }

  .font-color-1 {
    color: #FFFFFF;
  }

  .font-bold {
    font-weight: bold;
  }

  a {
    text-decoration: none;
    color: #fff;
  }

  .mobild-breadcrumb {
    line-height: 21px;
    margin-top: 8px;
  }
  .history {
    font-size: 12px;
    color: #727988;
  }
  .current-page {
    font-size: 14px;
    color: #E2E4E9;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue